export default __webpack_public_path__ + "static/media/yoga1.b8d2f7c5.jpeg";